'use strict';
import { modal } from './modal.js';


async function loadDatat() {
  const response = await fetch('./js/data/pets.json')
  let names = await response.json()
  let key;
  let mist = document.querySelector('.card__gridwrap');
  let gridWrap = document.querySelector('.card_wrapper');
  if(mist){
    for (key in names) {

      mist.innerHTML += `
      <li class="card__body">
      <div class="card__image"><img class="card-img" src="${names[key].img}" alt="${names[key].description}"></div>
              <p class="card__name">${names[key].name} </p>

              <button class="btn btn--learnmore card__btn" id="learnmore" data-modal-button="${names[key].data}">Learn more</button>
              </li>

              <div id="${names[key].data}" data-modal class="modal__wrapper hidden">
              <div class="modal__body">
              <img data-modal-close class="modal__close--btn" src="./img/modal_close_button.png" alt="close btn">
                <div class="modal__image">
                  <img src="${names[key].img}" alt="Pet photo" class="modal-img">
                </div>
                <div class="modal__text" data-modal>
                  <p class="modal__name">${names[key].name}</p>
                  <p class="modal__dogtype"><span class="modal__type">${names[key].type}</span> - <span class="modal__breed">${names[key].breed}</span></p>
                  <p class="modal__desqr">${names[key].description}</p>
                    <div class="modal__about">
                    <p class="modal__about--item">Age:<span class="modal__about--more">&thinsp;${names[key].age}</span></p>
                    <p class="modal__about--item">Inoculations:<span class="modal__about--more">&thinsp;${names[key].inoculations}</span></p>
                    <p class="modal__about--item">Diseases:<span class="modal__about--more">&thinsp;${names[key].diseases}</span></p>
                    <p class="modal__about--item">Age:<span class="modal__about--more">&thinsp;${names[key].parasites}</span></p>
                    </div>
                </div>
              </div>
            </div>
              `



    }
    modal()
  }

  }
  loadDatat()



